// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';
import Cocoen from 'cocoen';
import Masonry from 'masonry-layout';
import 'select2';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      setTimeout(function() {
        if ($that.width() / width > $that.height() / height) {
          $(this).css({
            width: '100%',
            height: 'auto',
          });
        } else {
          $(this).css({
            width: ($that.height() * width) / height,
            height: '100%',
          });
        }
      }, 1000);
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function() {
  /**
   * Custom Industries menu dropdown
   */
  $('.menu-item-dropdown > a').on('click', function(e) {
    e.preventDefault();
    $(this)
      .siblings('.submenu')
      .slideToggle();
  });

  /**
   * Custom select
   */
  $('.js-select2 select').select2({
    width: '100%',
    minimumResultsForSearch: Infinity,
  });

  /**
   * Gallery items grid
   */
  let gallery = document.getElementsByClassName('grid');
  function msnryInint() {
    if (gallery.length) {
      for (let i = 0; i < gallery.length; i++) {
        new Masonry(gallery[i], {
          columnWidth: '.grid-sizer',
          itemSelector: '.grid-item',
          percentPosition: true,
        });
      }
    }
  }
  //init
  msnryInint();
  // Init when tabs changes
  $('#galleryTabs').on('change.zf.tabs', function() {
    msnryInint();
  });

  /**
   * Upholstery tabs to dropdown
   */
  $('.upholstery-tabs__inner .tabs-placeholder').html(
    $('.upholstery-tabs__inner .tabs-title.is-active > a').html()
  );
  $('.upholstery-tabs__inner .tabs-placeholder').on('click', function() {
    $('.upholstery-tabs__inner .tabs').toggleClass('tabs--opened');
  });

  $('.upholstery-tabs__inner .tabs-title > a').on('click', function() {
    if (
      $(this)
        .closest('.upholstery-tabs__inner .tabs')
        .hasClass('tabs--opened')
    ) {
      $('.upholstery-tabs__inner .tabs-placeholder').html($(this).html());
      $(this)
        .closest('.upholstery-tabs__inner .tabs')
        .removeClass('tabs--opened');
    }
  });

  /**
   * Upholstery Page service slider
   */
  $('.upholstery-service__list').slick({
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  /**
   * Slide before/after on Upholstery Page
   */
  document.querySelectorAll('.cocoen').forEach(function(element) {
    new Cocoen(element);
  });

  /**
   * Gravity form placeholder and label animation
   */
  $(document).bind('gform_post_render', function() {
    $('.gfield').each(function() {
      var str;
      var startStr = $(this)
        .find('input, textarea')
        .val();
      if (startStr) {
        $(this)
          .find('.gfield_label')
          .addClass('gfield_label--active');
        $(this).addClass('gfield--active');
      }
      var gfield = $(this);

      $(this)
        .find('input, textarea')
        .on('input', function() {
          var input = $(this);
          str = input.val();
          if (str) {
            gfield.addClass('gfield--active');
            gfield.find('.gfield_label').addClass('gfield_label--active');
          } else {
            gfield.removeClass('gfield--active');
            gfield.find('.gfield_label').removeClass('gfield_label--active');
          }
        });
    });
  });

  /**
   * Input file add value to label
   */
  $('.file-upload input[type="file"]').on('change', function() {
    var file = $(this)[0].files[0].name;
    $(this)
      .parent()
      .siblings('label')
      .text(file);
  });

  /**
   * Blog single page sliders
   */
  $('.blog-single__slides .slider-main').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    asNavFor: '.blog-single__slides .slider-nav',
  });

  $('.blog-single__slides .slider-nav').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    asNavFor: '.blog-single__slides .slider-main',
  });

  /**
   * Industry page contact section sliders
   */
  $('.industry-contact__sliders-inner .slider-main').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    asNavFor: '.industry-contact__sliders-inner .slider-nav',
  });

  $('.industry-contact__sliders-inner .slider-nav').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    asNavFor: '.industry-contact__sliders-inner .slider-main',
  });

  /**
   * Home page Fabric section sliders
   */
  $('.home-fabric__slider-main').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    asNavFor: '.home-fabric__slider-nav',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });

  var sliderCount = +$('.home-fabric__slider-nav').data('count');
  $('.home-fabric__slider-nav').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: sliderCount - 1,
    rows: 0,
    asNavFor: '.home-fabric__slider-main',
  });

  /**
   * Fabric options slider slider
   */
  $('.fabric-options__list').slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /**
   * About history section slider
   */
  $('.about-history__list').slick({
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  /**
   * Fabric options slider slider
   */
  $('.fabric-suppliers__brands').slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /**
   * Home page Testimonials section slider
   */
  $('.home-testimonials__list').slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    //adaptiveHeight: true,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: 5000,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /**
   * Home page Gallery section slider
   */
  function add_class() {
    // Function to adding Next classes to slides
    $('.home-gallery__slider .slick-slide')
      .removeClass('Next')
      .removeClass('Next-second');
    $('.home-gallery__slider .slick-current')
      .next()
      .addClass('Next');
    $('.home-gallery__slider .slick-current')
      .nextAll()
      .eq(1)
      .addClass('Next-second');
  }

  $('.home-gallery__slider')
    .on('afterChange init', function() {
      // on change
      add_class();
    })
    .on('swipe', function() {
      // on swipe
      add_class();
    })
    .slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      //centerMode: true,
      //variableWidth: true,
      lazyLoad: false,
      //speed: 500,
      focusOnSelect: true,
    });

  // Init
  add_class();

  // Refresh
  var resizeTimer;
  $(window).on('resize', function() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function() {
      $('.home-gallery__slider').slick('refresh');
    }, 100);
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  jarallaxElement();
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.5,
  });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    treshold: 0.6,
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            var $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      } else if ($(element).is('.custom-list')) {
        $(element)
          .attr('data-scroll', 'out')
          .find('li')
          .each(function(i) {
            var $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function() {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  var scrollFixed;
  $(window)
    .on('toggled.zf.responsiveToggle', function() {
      $('.menu-icon').toggleClass('is-active');
      $('.logo').toggleClass('logo--mobile');

      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 1025) {
        scrollFixed = $(window).scrollTop();
        $('.body__inner').addClass('is-active');
      } else {
        $('.body__inner').removeClass('is-active');
        $(window).scrollTop(scrollFixed);
      }
    })
    .on('changed.zf.mediaquery', function() {
      $('.body__inner').removeClass('is-active');
      $('.menu-icon').removeClass('is-active');
      $('.logo').removeClass('logo--mobile');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function() {
    setTimeout(function() {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 1025) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  /**
   * Close responsive menu on click outside
   */
  $('body').on('click', function() {
    if ($('.menu-icon').hasClass('is-active')) {
      $('.menu-icon').trigger('click');
    }
  });

  $('.top-bar, .menu-icon, .title-bar-title, .title-bar').on('click', function(
    event
  ) {
    event.stopPropagation();
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
var oTop = $('#homeCounter').length
  ? $('#homeCounter').offset().top - window.innerHeight
  : false;
var a = 0;

// When section shown in a viewport
function isInViewport(node) {
  let rect = node.getBoundingClientRect();
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

$(window).on('scroll', function() {
  // Sticky header
  if ($(this).scrollTop() > 1) {
    $('.header__outer').addClass('sticky');
  } else {
    $('.header__outer').removeClass('sticky');
  }

  // Parallax background image
  if ($(window).width() > 1024) {
    var scrolledAbout = $(window).scrollTop();
    $('.home-gallery, .industry-contact').each(function() {
      var initY = $(this).offset().top,
        height = $(this).height();

      // Check if the element is in the viewport.
      var visible = isInViewport(this);
      if (visible) {
        var diff = scrolledAbout - initY;
        var ratio = Math.round((diff / height) * 100);
        $('.home-gallery__bg, .industry-contact__bg').css(
          'top',
          parseInt(-(ratio * 3)) + 'px'
        );
      }
    });
  }

  /**
   * Number counter for home page
   */
  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-value').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text(),
      }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
          },
        }
      );
    });
    a = 1;
  }
});
